import { useQuery } from '@tanstack/react-query';
import { startOfDay, subDays } from 'date-fns';
import { findConversations } from './api';
import { FindHistoryRequest } from './api.types';

export const useChatbotHistory = () => {
  const request: FindHistoryRequest = {
    from: subDays(startOfDay(Date.now()), 7).toISOString(),
    max_count: 100,
    history_type: 'full',
  };

  const { data, isLoading } = useQuery({
    queryKey: ['chatbotHistory', request],
    queryFn: () => findConversations(request),
  });

  const history = data ?? [];
  const hasHistory = history.length > 0;

  return { history, hasHistory, isLoading };
};
